new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');
            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                var inputElement = document.getElementById("valorParaCopiar");
                if (inputElement) {
                    var newValueInput = inputElement.value.replace(/^\/\//, '');
                    inputElement.value = newValueInput

                    if (formButton) {
                        formButton.addEventListener("click", (e) => {
                            e.preventDefault();

                            inputElement.select();

                            document.execCommand("copy");

                            window.getSelection().removeAllRanges();

                            alert("Valor copiado: " + newValueInput);
                        });
                    }
                }
            }
        });

        waitForElementToExist('.categories').then(element => {
            // Verifica se tem pelo menos 5 filhos em desktop
            if (window.innerWidth >= 992) {
                const container = document.querySelector('#categories-home-carrousel');
                const items = Array.from(container.children);
                
                if (items.length < 5) {
                    // Não inicializa o slick se tiver menos de 5 itens em desktop
                    console.log('Slick não inicializado - menos de 5 itens em desktop:', items.length);
                    return;
                }
            }
            
            $('#categories-home-carrousel').slick({
                arrows: false,
                dots: false,
                autoplay: false,
                autoplaySpeed: 3000,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 1000,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 3,
                            arrows: true
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 6,
                            arrows: true
                        }
                    }
                ]
            });
        });
    }
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        swipeToSlide: true, 
        touchThreshold: 100,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        dots: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 300,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.home-product__list.last').then(element => {
        let rotationShowcase = document.querySelector('.home-product__list.last');
        if (rotationShowcase) {
            let rotationShowcaseNames = rotationShowcase.querySelectorAll('.content-text h3');
            let initShowcase = rotationShowcase.querySelectorAll('.product_list.last ');
            initShowcase = Array.from(initShowcase);
        
            if(rotationShowcase && rotationShowcaseNames.length && initShowcase.length) {
                initShowcase[0].classList.add('active');
                rotationShowcaseNames[0].classList.add('active');
        
                function activeTab(index) {
                    initShowcase.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationShowcaseNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initShowcase[index].classList.add('active');
                    rotationShowcaseNames[index].classList.add('active');
    
                    $('#product_list-1').slick('refresh');
                    $('#product_list-2').slick('refresh');
                }
        
                rotationShowcaseNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                })
            }

            $('#product_list-1').slick({
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToShow: 4
                        }
                    }
                ]
            });

            $('#product_list-2').slick({
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToShow: 4
                        }
                    }
                ]
            });
        }
    });

    waitForElementToExist('.product-ratings').then(element => {
        const productRatings = element.querySelector('.product-ratings-list');
        if(productRatings) {
            $('.product-ratings-list').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: false,
                dots: false,
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 3000,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                            dots: false,
                            arrows: true,
                            adaptiveHeight: true,
                        }
                    },
                ]
            });

            $('.product-ratings-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.home-product__list.last-two').then(element => {
        let rotationShowcase = document.querySelector('.home-product__list.last-two');
        if (rotationShowcase) {
            let rotationShowcaseNames = rotationShowcase.querySelectorAll('.content-text h3');
            let initShowcase = rotationShowcase.querySelectorAll('.product_list.last');
            initShowcase = Array.from(initShowcase);
        
            if(rotationShowcase && rotationShowcaseNames.length && initShowcase.length) {
                initShowcase[0].classList.add('active');
                rotationShowcaseNames[0].classList.add('active');
        
                function activeTab(index) {
                    initShowcase.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationShowcaseNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initShowcase[index].classList.add('active');
                    rotationShowcaseNames[index].classList.add('active');
    
                    $('#product_list-3').slick('refresh');
                    $('#product_list-4').slick('refresh');
                }
        
                rotationShowcaseNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                })
            }

            $('#product_list-3').slick({
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToShow: 4
                        }
                    }
                ]
            });

            $('#product_list-4').slick({
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToShow: 4
                        }
                    }
                ]
            });
        }
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list');
        if(vitrineCarrousel) {
            $('#product_list').slick({
                initialSlide: 1,
                adaptiveHeight: true,
                arrows: false,
                dots: true,
                swipeToSlide: true, 
                touchThreshold: 100,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            dots: false,
                            initialSlide: 0,
                            slidesToShow: 4,
                            slidesToShow: 4,
                        }
                    },
                ]
            });

            $('#product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list2');
        if(vitrineCarrousel) {
            $('#product_list2').slick({
                initialSlide: 1,
                adaptiveHeight: true,
                arrows: false,
                dots: true,
                swipeToSlide: true, 
                touchThreshold: 100,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            dots: false,
                            initialSlide: 0,
                            slidesToShow: 4,
                            slidesToShow: 4,
                        }
                    },
                ]
            });

            $('#product_list2').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list3');
        if(vitrineCarrousel) {
            $('#product_list3').slick({
                initialSlide: 1,
                adaptiveHeight: true,
                arrows: false,
                dots: true,
                swipeToSlide: true, 
                touchThreshold: 100,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            dots: false,
                            initialSlide: 0,
                            slidesToShow: 4,
                            slidesToShow: 4,
                        }
                    },
                ]
            });

            $('#product_list3').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.faixa-comunicado').then(element => {
        $('.faixa-comunicado-content').slick({
            arrows: false,
            swipeToSlide: true, 
            touchThreshold: 100,
            autoplay: true,
            autoplaySpeed: 1500,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
            responsive: [
                {
                    breakpoint: 992,
                    settings: 'unslick'
                },
            ]
        });
    });

});